'use client';

import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled from 'styled-components';
import { colors } from '../Utils/constants.js';

var STContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: 30px;\n    padding: 8px;\n    border-radius: 6px;\n    font-size: 12px;\n    line-height: 15px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n\n    ", "\n\n    &.customBg {\n        background: ", ";\n    }\n"], ["\n    height: 30px;\n    padding: 8px;\n    border-radius: 6px;\n    font-size: 12px;\n    line-height: 15px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n\n    ", "\n\n    &.customBg {\n        background: ", ";\n    }\n"])), function (_a) {
    var isActive = _a.isActive;
    return "\n        background: ".concat(isActive ? '#EBF2FF' : '#fff', " ;\n        border: ").concat(isActive ? '1px solid rgba(0, 90, 255, 0.2)' : 'unset', ";\n        color: ").concat(isActive ? colors.primaryColor : colors.textColor, ";\n        font-weight: ").concat(isActive ? 500 : 400, ";\n    ");
}, function (_a) {
    var isActive = _a.isActive;
    return (isActive ? '#EBF2FF' : '#F1F2F4');
});
var templateObject_1;

export { STContainer };
//# sourceMappingURL=styles.js.map
